import { Component, h, JSX } from 'preact';
import { hexToRGBA } from '../../../../../../common/js/colors';
import { sendCreativeCloseButtonClick } from '../../../../../../common/js/TrackAnalyticsHelper';
import InformationLabel from '../../../../../../common/components/information-label';
import CustomizedControl from '../../../../../../common/components/customized-control';
import CloseControl from '../../../../../../common/components/close-control';
import { ClickArea } from '../../../../../../common/components/click-area';
import { ButtonBase } from '../../../../../../common/components/button-base';

interface ControlStyle {
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
}

interface CtaCloseItemProps {
  closeButtonSize: number;
  onClose: (e: MouseEvent) => void;
  closingScheduledIn?: number;
  showCloseDelay: boolean;
  controlStyle: ControlStyle;
  remainingTime: number;
  showRecommendation: boolean;
  canInstallIcon: boolean;
  isReversed: boolean;
  showClose: boolean;
  showCloseDisabled?: boolean;
  elapsedTime: number;
  clickCloseTime?: number;
}

export class CtaCloseItem extends Component<CtaCloseItemProps> {
  constructor(props: CtaCloseItemProps) {
    super(props);
  }

  render(): JSX.Element | string {
    const {
      closeButtonSize,
      onClose,
      closingScheduledIn,
      showCloseDelay,
      controlStyle,
      remainingTime,
      showRecommendation,
      canInstallIcon,
      isReversed,
      showClose,
      showCloseDisabled,
      elapsedTime,
      clickCloseTime
    } = this.props;
    const containerStyle = {
      display: 'inline-flex',
      flexDirection: isReversed ? ('row-reverse' as const) : ('row' as const),
      background: hexToRGBA(
        controlStyle.backgroundColor,
        controlStyle.backgroundOpacity
      ) as string,
      color: hexToRGBA(
        controlStyle.labelColor,
        controlStyle.labelOpacity
      ) as string,
      fill: hexToRGBA(
        controlStyle.labelColor,
        controlStyle.labelOpacity
      ) as string,
      fontSize: 13,
      borderRadius: 6,
      alignItems: 'center' as const,
      minHeight: 36
    };
    const showCloseButton =
      !closingScheduledIn || (closingScheduledIn && showCloseDelay);
    const paddingBetweenElement = showClose || showCloseDisabled ? 8 : 12;

    const canShowInformationLabel = Boolean(
      showRecommendation || canInstallIcon || showCloseDelay
    );
    const informationLabelItem = canShowInformationLabel ? (
      <InformationLabel
        remainingTime={remainingTime}
        showRecommendation={showRecommendation}
        canInstallIcon={canInstallIcon}
        styles={{
          paddingLeft: isReversed ? paddingBetweenElement : 12,
          paddingRight: !isReversed ? paddingBetweenElement : 12
        }}
      />
    ) : (
      ''
    );

    const closeItem =
      showClose || showCloseDisabled ? (
        <ButtonBase
          style={{
            transform: `scale(${closeButtonSize / 100}, ${closeButtonSize /
              100})`,
            WebkitTransform: `scale(${closeButtonSize /
              100}, ${closeButtonSize / 100})`,
            transformOrigin: 'center center',
            WebkitTransformOrigin: 'center center'
          }}
          aria-label="ogury_close_button"
          data-zone="close_cta_button"
          id="close_cta_button"
        >
          <ClickArea
            onTouchStart={(e: TouchEvent) => e.stopPropagation()}
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              if (showCloseDisabled) return;
              sendCreativeCloseButtonClick();
              onClose(e);
            }}
            canIncreaseAreaForTablet={false}
          >
            {showCloseButton ? (
              <CustomizedControl
                id="close_cta"
                controlStyle={{ ...controlStyle }}
                style={{ padding: closingScheduledIn ? 9 : 10 }}
              >
                <CloseControl
                  closingScheduledIn={closingScheduledIn}
                  isCross={true}
                  isDisabled={showCloseDisabled}
                  elapsedTime={elapsedTime}
                  clickCloseTime={clickCloseTime}
                />
              </CustomizedControl>
            ) : (
              ''
            )}
          </ClickArea>
        </ButtonBase>
      ) : (
        ''
      );

    return closeItem || informationLabelItem ? (
      <div style={containerStyle}>
        {informationLabelItem}
        {closeItem}
      </div>
    ) : (
      ''
    );
  }
}
